export default __webpack_public_path__ + "793c360ae2db1324887d86e659610f7a.png";